const formats = {
  video: ["mp4", "webm"], //mov
  audio: ["mp3", "wav"],
  word: ["doc", "docx", "txt"], //dot
  pdf: ["pdf"],
  ppt: ["ppt", "pptx"],
  zip: ["zip", "rar"],
  image: ["png", "jpeg", "svg", "gif", "heic", "jpg"], //heic,jpg
  url: ["url"],
  xlsx: ["xlsx"], //xls,csv
};

export default formats;

export const certificateUploadFormats = {
  pdf: ["pdf"],
  image: ["png", "jpeg", "svg", "gif", "heic", "jpg"],
};

// export  certificateUploadFormats;
